import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'
import { WhiteBlock } from '~/shared/ui/Wrappers'

export const PendingWrapper = styled(WhiteBlock)`
  display: flex;
`

export const PendingDescription = styled.div`
  margin-left: 6px;
  color: ${myPalette.coral.main};
  font-weight: 500;
`
